import divider from './divider.vue'
divider.install = function (Vue) {
  Vue.component(divider.name, divider);
};
export default divider



// WEBPACK FOOTER //
// ./src/ni-ui/divider/index.js